import { InfoDialogItem } from "src/app/models/info-dialog";

export class OpenDialog {
  static readonly type = '[Info] - Open dialog';

  constructor(public title: string, public description: string, public content: InfoDialogItem[], public showActions: boolean) { }
}

export class CloseDialog {
  static readonly type = '[Info] - Close dialog';
}
